export const enum VisualizationsQa {
    Line = 'visualization-item-line',
    Area = 'visualization-item-area',
    Area100p = 'visualization-item-area100p',
    Column = 'visualization-item-column',
    Column100p = 'visualization-item-column100p',
    Bar = 'visualization-item-bar',
    Bar100p = 'visualization-item-bar100p',
    BarXD3 = 'visualization-item-bar-x-d3',
    BarYD3 = 'visualization-item-bar-y-d3',
    Scatter = 'visualization-item-scatter',
    ScatterD3 = 'visualization-item-scatter-d3',
    Pie = 'visualization-item-pie',
    PieD3 = 'visualization-item-pie-d3',
    Donut = 'visualization-item-donut',
    DonutD3 = 'visualization-item-donut-d3',
    Metric = 'visualization-item-metric',
    Treemap = 'visualization-item-treemap',
    TreemapD3 = 'visualization-item-treemap-d3',
    FlatTable = 'visualization-item-flatTable',
    PivotTable = 'visualization-item-pivotTable',
    Geolayer = 'visualization-item-geolayer',
    CombinedChart = 'visualization-item-combined-chart',
}
